// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap-UaQhLK{justify-content:center;align-items:center;gap:12px;display:flex}.icon-aRPcoZ{-o-object-fit:contain;object-fit:contain;flex-shrink:0;width:32px;height:32px}.wordmark-f5ncoU{color:#1e40af;letter-spacing:-.02em;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,sans-serif;font-size:36px;font-weight:700;line-height:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `wrap-UaQhLK`,
	"icon": `icon-aRPcoZ`,
	"wordmark": `wordmark-f5ncoU`
};
export default ___CSS_LOADER_EXPORT___;
